import { useIntl } from 'react-intl';

const lvOrder = 'aābcčdeēfgģhiījkķlļmnņoprsštuūvzž';

// @ts-ignore
const order = [...lvOrder];

function lvValue(char: string) {
  const idx = order.indexOf(char.toLowerCase());
  return idx === -1 ? 999 : idx;
}

function useSort() {
  function lvSort(a: string, b: string) {
    const as = a.toLowerCase();
    const bs = b.toLowerCase();

    for (let i = 0; i < Math.min(as.length, bs.length); i++) {
      const diff = lvValue(as[i]) - lvValue(bs[i]);
      if (diff !== 0) return diff;
    }

    return as.length - bs.length;
  }

  return { lvSort };
}

export default useSort;
